import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Info = () => {
  return (
    <main className="min-h-screen bg-frost-vanilla py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-16">Shipping & Returns</h1>
        
        <div className="space-y-12">
          <section className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-frost-ice">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-frost-ice p-4 rounded-full text-frost-berry">
                <SafeIcon icon="FiTruck" className="text-2xl" />
              </div>
              <h2 className="text-3xl font-bold">How We Ship</h2>
            </div>
            <div className="prose prose-lg text-gray-600">
              <p>Because our products are highly perishable, we utilize a strict <strong>cold-chain logistics</strong> process. All orders are packed in custom insulated coolers with enough dry ice to keep the contents at -109°F for up to 48 hours in transit.</p>
              <ul className="list-disc pl-5 mt-4 space-y-2">
                <li><strong>Order Cutoff:</strong> Wednesday at 11:59 PM EST.</li>
                <li><strong>Shipping Days:</strong> We ship all batches on Mondays to prevent weekend transit delays.</li>
                <li><strong>Delivery Area:</strong> Lower 48 United States only. No PO Boxes.</li>
              </ul>
            </div>
          </section>

          <section className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-frost-ice">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-frost-berry/10 p-4 rounded-full text-frost-berry">
                <SafeIcon icon="FiAlertTriangle" className="text-2xl" />
              </div>
              <h2 className="text-3xl font-bold">Dry Ice Safety</h2>
            </div>
            <div className="prose prose-lg text-gray-600">
              <p>Your package will contain dry ice. <strong>DO NOT TOUCH DRY ICE WITH BARE HANDS.</strong> It can cause severe burns.</p>
              <p>Leave the dry ice in the cooler in a well-ventilated area until it completely sublimates (turns into gas), which usually takes 24 hours. Do not dispose of it in a sink, toilet, or trash can.</p>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default Info;